import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SettingsInterface } from '../../common/types/interfaces'

export type ColorSchemeType =
  | 'cyberpunk'
  | 'green'
  | 'purple'
  | 'blue'
  | 'orange'
  | 'pink'
  | 'red'
  | 'teal'
  | 'silver'

const getInitialColorScheme = (): ColorSchemeType => {
  const saved = localStorage.getItem('colorScheme')
  if (
    saved &&
    ['cyberpunk', 'green', 'purple', 'blue', 'orange', 'pink', 'red', 'teal', 'silver'].includes(
      saved,
    )
  ) {
    return saved as ColorSchemeType
  }
  return 'cyberpunk'
}

const initialState: { data: SettingsInterface & { colorScheme: ColorSchemeType } } = {
  data: {
    darkTheme: localStorage.getItem('theme') === 'DARK' ? true : false,
    soundEnabled: localStorage.getItem('soundEnabled') === 'true' ? true : false,
    colorScheme: getInitialColorScheme(),
  },
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      localStorage.setItem('theme', !state.data.darkTheme ? 'DARK' : 'LIGHT')
      state.data = { ...state.data, darkTheme: !state.data.darkTheme }
    },
    setSoundEnabled: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem('soundEnabled', action.payload.toString())
      state.data = { ...state.data, soundEnabled: action.payload }
    },
    setColorScheme: (state, action: PayloadAction<ColorSchemeType>) => {
      localStorage.setItem('colorScheme', action.payload)
      state.data = { ...state.data, colorScheme: action.payload }
    },
  },
})

export const { toggleTheme, setSoundEnabled, setColorScheme } = settingsSlice.actions
export const selectDarkTheme = (state: RootState) => state.settings.data.darkTheme
export const selectSoundEnabled = (state: RootState) => state.settings.data.soundEnabled
export const selectColorScheme = (state: RootState) => state.settings.data.colorScheme

export default settingsSlice.reducer
